let baseUrl: string = "https://bm-maps.com"; // Standardwert

// fuer Server:
// let baseUrl: string = "https://bm-maps.com";

// fuer Lokal:
// let baseUrl: string = "http://localhost:3000";

/**
 * Setzt die Basis-URL für API-Anfragen.
 * @param url - Die neue Basis-URL.
 */
export const setBaseUrl = (url: string): void => {
    baseUrl = url;
};

/**
 * Gibt die aktuelle Basis-URL zurück.
 * @returns Die aktuelle Basis-URL.
 */
export const getBaseUrl = (): string => baseUrl;